import Link from "next/link";
import { CTA } from "@/lib/cta";

export type EventCardProps = {
  title: string;
  href: string;
  dateLabel: string;
  isTBA?: boolean; // DA CONFERMARE - se non presenta ancora la data
  isToday?: boolean; // OGGI
  isTomorrow?: boolean; // DOMANI
  isThisWeekend?: boolean; // QUESTO WEEKEND
  isThisWeek?: boolean; // QUESTA SETTIMANA
  isComingSoon?: boolean; // IN ARRIVO - se data presente ma non negli stati sopra
  isConcluded?: boolean; // CONCLUSA - se data nel passato
  isFree?: boolean;
  locality: string;
  distanceKm?: number;
  tags?: string[];
  motherHref?: string; // link info secondario ("Scopri di più")
};

export function EventCard({
  title,
  href,
  dateLabel,
  isTBA,
  isToday,
  isTomorrow,
  isThisWeekend,
  isThisWeek,
  isComingSoon,
  isConcluded,
  isFree,
  locality,
  distanceKm,
  tags = [],
  motherHref,
}: EventCardProps) {
  // Priorità: OGGI > DOMANI > QUESTO WEEKEND > QUESTA SETTIMANA > IN ARRIVO > CONCLUSA > DA CONFERMARE
  const status = isToday
    ? "today"
    : isTomorrow
      ? "tomorrow"
      : isThisWeekend
        ? "weekend"
        : isThisWeek
          ? "week"
          : isComingSoon
            ? "soon"
            : isConcluded
              ? "concluded"
              : isTBA
                ? "tba"
                : "neutral";

  const statusText =
    status === "today"
      ? "OGGI"
      : status === "tomorrow"
        ? "DOMANI"
        : status === "weekend"
          ? "QUESTO WEEKEND"
          : status === "week"
            ? "QUESTA SETTIMANA"
            : status === "soon"
              ? "IN ARRIVO"
              : status === "concluded"
                ? "CONCLUSA"
                : status === "tba"
                  ? "DA CONFERMARE"
                  : "";

  return (
    <article
      className={`event-card2 event-card2--${status}`}
      aria-label={`${title}, ${dateLabel}, ${locality}`}
    >
      {/* Card bianca sopra */}
      <div className="event-card2__inner">
        <Link href={href} className="event-card2__link">
          <p className="event-card2__title" role="heading" aria-level={3}>{title}</p>

          <div className="event-card2__meta">
            <p className="event-card2__meta-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
              <span>
                {locality}
                {typeof distanceKm === "number" && (
                  <span className="event-card2__distance"> · {Math.round(distanceKm)} km</span>
                )}
              </span>
            </p>

            <p className="event-card2__meta-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                <line x1="16" x2="16" y1="2" y2="6" />
                <line x1="8" x2="8" y1="2" y2="6" />
                <line x1="3" x2="21" y1="10" y2="10" />
              </svg>
              <span>{dateLabel}</span>
            </p>
          </div>

          {(isFree || tags.length > 0) && (
            <div className="event-card2__tags">
              {isFree && <span className="chip chip--ghost">Gratis</span>}
              {tags.slice(0, 3).map((tag) => (
                <span key={tag} className="chip">
                  {tag}
                </span>
              ))}
            </div>
          )}
        </Link>

        {motherHref && (
          <div className="event-card2__more">
            <Link href={motherHref} className="event-card-info-link">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
              {CTA.sagraDetail}
            </Link>
          </div>
        )}
      </div>

      {/* Fascia colorata in basso, centrata, senza badge */}
      <div className="event-card2__statusbar" aria-hidden="true">
        <span className="event-card2__status-text">{statusText}</span>
      </div>
    </article>
  );
}
